import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { ContainerTypeLegacy, CreateGrainBinWizard, navigateTo, useAuth } from '@amber-ui/core';

function CreateGrainBinRoute() {
  const { acct } = Route.useSearch();
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const onCreateSuccess = useCallback(
    ({ grain_bin_id, bin_name }: { grain_bin_id: string; bin_name: string }) => {
      navigateTo('/grain_bin/dashboard', {
        container_name: bin_name,
        container_id: grain_bin_id,
        container_type: ContainerTypeLegacy.bin,
      });
    },
    []
  );

  return <CreateGrainBinWizard account_id={effectiveAccountId} onCreateSuccess={onCreateSuccess} />;
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/create')({
  component: CreateGrainBinRoute,
});
